import React from 'react'

const ProfessionalLetter = (props: any) => {
    const { fill } = props
  return (
    <svg
      width="51"
      height="51"
      viewBox="0 0 51 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1435_1353)">
        <path
          d="M48.0905 22.6074L43.9147 18.4315V5.74449C43.9147 5.20902 43.4806 4.77496 42.9451 4.77496H30.2581L26.1792 0.69606C25.8006 0.317459 25.1867 0.317459 24.808 0.69606L20.7291 4.77496H8.04215C7.50668 4.77496 7.07262 5.20902 7.07262 5.74449V18.4314L2.89677 22.6073C2.71498 22.7892 2.61279 23.0358 2.61279 23.2929V49.0824C2.61279 49.6178 3.04685 50.0519 3.58232 50.0519H21.1308C21.6662 50.0519 22.1003 49.6178 22.1003 49.0824C22.1003 48.5469 21.6662 48.1128 21.1308 48.1128H5.92305L25.4936 28.5421L45.0643 48.1128H29.8565C29.321 48.1128 28.887 48.5469 28.887 49.0824C28.887 49.6178 29.321 50.0519 29.8565 50.0519H47.405C47.9404 50.0519 48.3745 49.6178 48.3745 49.0824V23.2929C48.3745 23.0358 48.2723 22.7892 48.0905 22.6074ZM46.4354 25.6337V46.7417L35.8814 36.1876L46.4354 25.6337ZM46.0339 23.2929L43.9147 25.4121V21.1738L46.0339 23.2929ZM25.4936 2.75272L27.5159 4.77496H23.4714L25.4936 2.75272ZM4.55185 25.6337L15.1058 36.1876L4.55185 46.7417V25.6337ZM7.07262 25.4121L4.95343 23.2929L7.07262 21.1738V25.4121ZM24.8081 26.4855L16.477 34.8165L9.01167 27.3512V6.71401H41.9756V27.3511L34.5102 34.8164L26.1792 26.4854C25.8006 26.1069 25.1867 26.1069 24.8081 26.4855Z"
          fill="black"
        />
        <path
          d="M25.4935 48.1123C25.2385 48.1123 24.9883 48.216 24.808 48.3964C24.6277 48.5767 24.5239 48.8268 24.5239 49.0818C24.5239 49.3368 24.6277 49.587 24.808 49.7673C24.9883 49.9476 25.2385 50.0514 25.4935 50.0514C25.7484 50.0514 25.9986 49.9476 26.1789 49.7673C26.3592 49.587 26.463 49.3368 26.463 49.0818C26.463 48.8268 26.3592 48.5767 26.1789 48.3964C25.9986 48.216 25.7484 48.1123 25.4935 48.1123Z"
          fill="black"
        />
        <path
          d="M16.7356 12.1432H34.2518C34.7873 12.1432 35.2213 11.7091 35.2213 11.1736C35.2213 10.6382 34.7873 10.2041 34.2518 10.2041H16.7356C16.2002 10.2041 15.7661 10.6382 15.7661 11.1736C15.7661 11.7091 16.2002 12.1432 16.7356 12.1432Z"
          fill="black"
        />
        <path
          d="M35.2213 16.6033C35.2213 16.0678 34.7873 15.6338 34.2518 15.6338H16.7356C16.2002 15.6338 15.7661 16.0678 15.7661 16.6033C15.7661 17.1388 16.2002 17.5728 16.7356 17.5728H34.2518C34.7873 17.5728 35.2213 17.1388 35.2213 16.6033Z"
          fill="black"
        />
        <path
          d="M30.6323 21.0625H20.3553C19.8198 21.0625 19.3857 21.4966 19.3857 22.032C19.3857 22.5675 19.8198 23.0016 20.3553 23.0016H30.6323C31.1677 23.0016 31.6018 22.5675 31.6018 22.032C31.6018 21.4966 31.1677 21.0625 30.6323 21.0625Z"
          fill="black"
        />
        <path
          d="M5.73926 48.0261L25.4939 28.2715L45.2485 48.0261H5.73926Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_1435_1353">
          <rect
            width="49.6398"
            height="49.6398"
            fill="white"
            transform="translate(0.673828 0.412109)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default ProfessionalLetter;